module.exports = __webpack_public_path__ + "img/activeskilltest.cd383b5d.svg";